<template>
    <div class="p-3">
        <form-modal
            id="anexo6_1"
            placeholder-button="Inserir" 

            :title-modal="titulo"

            :fields="colunas"
            :values="dados"

            ref="modalForm"

            read
            update
            remove

            controles

            @ok="salvar"
            @edit="editar"
            @cancel="fechar"
        >
            <template #modal>                
                <modal :form="form" ref="modal" />
            </template>

            <template #table>
                <div>
                        
                    <filtro ref="filtro" @buscar="buscar"/>

                    <div class="table-responsive">
                        <b-table
                            @row-dblclicked="editar"
                            head-variant="dark"
                            :fields="colunas"
                            :items="dados"
                        >
                            <template #cell(actions)="data">
                                <div class="d-flex">
                                    <b-button v-if="!data.item.modificado ? permissao.c : permissao.u" @click="editar(data.item)" :variant="!data.item.modificado ? 'flat-info' : 'flat-primary'">
                                        <i v-if="data.item.modificado" class="fas fa-edit mr-2"></i>
                                        <i v-if="!data.item.modificado" class="fas fa-plus mr-2"></i>
                                        {{!data.item.modificado ? 'Inserir' : 'Editar'}} baixas
                                    </b-button>
                                </div>
                            </template>
                        </b-table>                          
                    </div>  
                </div>
            </template>
        </form-modal>
    </div>
</template>
<script>
import FormModal from "@/components/modal/FormModal";
import cloneDeep from "lodash/cloneDeep";
import MovimentacaoFinanceiraService from "@/common/services/movimentacao_financeira/movimentacao_financeira.service";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";
import {FormMixin} from "@/common/mixins/FormMixin";
import helpers from "@/common/utils/helpers";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import Modal from "./modal";
import Filtro from "../Filtro";

export default {
    mixins: [AlertasMixin, FormMixin],
    components: {
        FormModal,
        Modal,
        Filtro
    },
    props: {
        empresaId: {
            type: String,
            required: true
        },
    },
    data: () => ({
        form : {
            ano: "",
            mes: "",
            receitas: [],
            deducoes: [],
        },
        colunas : [],
        dados : [],
        titulo : "",
        
    }),
    mounted(){
        //this.buscar();
    },
    methods : {
        montar : function(){            
            this.inicializarColunas();
            this.$refs['filtro'].montar();
        },
        adicionar : function(){
            this.$refs.modalForm.openModal();
        },
        inicializarColunas : function(){
            this.colunas = [
                {key : "ano", label : "Ano"},
                {key : "mes", label : "Mês", formatter : (valor) => {
                    return valor == "Marco" ? "Março" : valor;
                }},
                {key : "saldoInicial", label : "Saldo inicial", 
                    formatter : (value) => helpers.formatarValor(value)
                },
                {key : "pd", label : "P&D", 
                    formatter : (value) => helpers.formatarValor(value)
                },
                {key : "mme", label : "MME", 
                    formatter : (value) => helpers.formatarValor(value)
                },
                {key : "fndct", label : "FNDCT", 
                    formatter : (value) => helpers.formatarValor(value)
                },
                {key : "aplicacaoODS", label : "Aplicação ODS", 
                    formatter : (value) => helpers.formatarValor(value)
                },
            ];


            if(this.empresaSelecionada.segmento == 'Distribuicao'){
                this.colunas.push(...[
                    {key : "cdepd", label : "CDE P&D",
                        formatter :(value) => {
                            return helpers.formatarValor(value);
                        }
                    },
                    {key : "cdepee", label : "CDE PEE",
                        formatter :(value) => {
                            return helpers.formatarValor(value);
                        }
                    },
                    {key : "procel", label : "PROCEL", 
                        formatter : (value) => helpers.formatarValor(value)
                    },
                    
                ]);
            }else{
                this.colunas.push({key : "cde", label : "CDE",
                    formatter :(value) => {
                        return helpers.formatarValor(value);
                    }
                },);
            }

            this.colunas.push(...[
                {key : "juros", label : "Juros (SELIC)", 
                    formatter : (value) => helpers.formatarValor(value)
                
                },
            ]);

            if(this.empresaSelecionada.segmento != 'Distribuicao' && this.empresaSelecionada.segmento != 'Transmissao'){
                this.colunas.push(...[
                    {key : "pee", label : "Baixa PEE",
                        formatter :(value) => {
                            return helpers.formatarValor(value);
                        }
                    },
                    {key : "baixasCDE", label : "Baixa CDE", 
                        formatter : (value) => helpers.formatarValor(value)
                    },
                ]);
            }

            this.colunas.push(...[
                {key : "baixasMME", label : "Baixa MME", 
                    formatter : (value) => helpers.formatarValor(value)
                },
                {key : "baixasFNDCT", label : "Baixa FNDCT", 
                    formatter : (value) => helpers.formatarValor(value)
                },
            ]);

            if(this.empresaSelecionada.segmento == 'Distribuicao'){
                this.colunas.push(...[
                    {key : "baixasCDEPEE", label : "Baixa CDE PEE", 
                        formatter : (value) => helpers.formatarValor(value)
                    },
                    {key : "baixasCDEPD", label : "Baixa CDE P&D", 
                        formatter : (value) => helpers.formatarValor(value)
                    },
                    {key : "baixasPROCEL", label : "Baixa PROCEL", 
                        formatter : (value) => helpers.formatarValor(value)
                    },
                ]);
            }
                
            this.colunas.push(...[
                {key : "saldoFinal", label : "Saldo final", 
                    formatter : (value) => helpers.formatarValor(value)
                },
                {key : "actions", label : "Ações"},
            ]);
        },
        fechar : function(){
            this.$refs['filtro'].buscar();
            this.form = {}
        },
        salvar : function(){
            let form = cloneDeep(this.form);
            if(!this.$refs.modal.validateState())
                return;

            this.confirmar('Aviso','Deseja salvar?').then(confirmado => {
                if(confirmado){

                    form.pee = helpers.removerValor(form.pee);
                    form.baixasMME = helpers.removerValor(form.baixasMME);
                    form.baixasFNDCT = helpers.removerValor(form.baixasFNDCT);
                    form.baixasCDE = helpers.removerValor(form.baixasCDE);

                    form.baixasCDEPEE = helpers.removerValor(form.baixasCDEPEE);
                    form.baixasCDEPD = helpers.removerValor(form.baixasCDEPD);
                    form.baixasPROCEL = helpers.removerValor(form.baixasPROCEL);

                    this.$store.dispatch(START_LOADING);
                    MovimentacaoFinanceiraService.salvarBaixas(form).then(() => {
                        this.alertaSucesso('Salvo com sucesso!').then(() => {
                            this.$refs.modalForm.closeModal();
                            this.buscar();
                        });
                    }).catch(err => {
                         if(err.response.status == 400){
                            this.alertaErro(err.response.data.errors);
                        }else   
                            this.alertaErro("Erro ao salvar");
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                }
            })
        },

        editar : function(item){
            if(item.modificado ? !this.permissao.u : !this.permissao.c)
                return;

            if(item.modificado){
                this.titulo = "Editar baixas";
            }else{
                this.titulo = "Inserir baixas";
            }

            let form = cloneDeep(item);
            form.pee = helpers.formatarValor(form.pee);
            form.baixasMME = helpers.formatarValor(form.baixasMME);
            form.baixasFNDCT = helpers.formatarValor(form.baixasFNDCT);
            form.baixasCDE = helpers.formatarValor(form.baixasCDE);
            
            form.baixasCDEPEE = helpers.formatarValor(form.baixasCDEPEE);
            form.baixasCDEPD = helpers.formatarValor(form.baixasCDEPD);
            form.baixasPROCEL = helpers.formatarValor(form.baixasPROCEL);

            this.form = form;
            this.$refs.modalForm.openModal();
        },

        buscar : function(filtro){
            this.$store.dispatch(START_LOADING);
            MovimentacaoFinanceiraService.listarAnexo6_1(this.empresaId, filtro.ano, filtro.anoFim, filtro.mesInicio, filtro.mesFim).then(response => {
                this.dados = response.data.data;
            }).catch(() => {
                this.alertaErro("Erro ao buscar");
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
    },
    computed : {
        empresaSelecionada : function(){
            return this.$store.state.app.selectedCompanyObj;
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('MovimentacaoFinanceiraAnexo61');
        }
    }
}
</script>
<style lang="">
    
</style>